import React from "react"
import {Grid} from "@material-ui/core"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import {NavLink} from "react-router-dom"
import ClassNames from "classnames"
const useStyles = makeStyles({
    contentContainer:{
        borderWidth:"2px",
     fontFamily: ['Syne Tactile', 'cursive'],
     paddingTop:"12%"

     
    }
    ,
    Typography:{
        width:"50%",
        marginLeft:"25%",
        fontFamily:['Luckiest Guy', "cursive"],
    },
    
    writing:{
        fontFamily:["Syne Tactile",  "cursive"],
        color:"white"

    },
    Button:{
        backgroundImage:`url(${"https://media.giphy.com/media/ZZlv7lvTf4LVQkSind/giphy.gif"})`,
        backgroundSize:"cover",
        marginTop:"2%",
    padding:"1%",
    paddingLeft:"5%",
    paddingRight:"5%",
    borderRadius:"14px",
    fontWeight:"Bold",
    fontFamily:['Luckiest Guy', "cursive"],
    
    },
    Navlink:{
        color:"white"
        
    }

})


const shonen=()=>{
    const classes = useStyles()
    return (
   <Grid>
   <Grid item md="12" xs="12">
   <Typography variant="h3" className={classes.writing}>
        Romantic And Highschool
    </Typography>
    </Grid>
    <Grid item md="12" xs="12" className={ classes.contentContainer}>
    </Grid>
    <Grid item md="12" xs="12" >
  
    <Button variant="contained" className={classes.Button} ><NavLink className={classes.Navlink} to="romenticDimension"> Enter The Dimension</NavLink></Button>
  </Grid>
    </Grid>
    )}
export default shonen


// WEBPACK FOOTER //
// ./src/Component/catagories/Romantic.jsx